// Labels for the Transaksi list & detail panel (id / en / zh).
const D = {
  sendWorkflow: ["Kirim ke Workflow", "Send to Workflow", "提交审批流程"],
  checkL1: ["Periksa (L1)", "Check (L1)", "审核 (L1)"],
  askRevision: ["Minta Revisi", "Request Revision", "要求修改"],
  approveL2: ["Setujui (L2)", "Approve (L2)", "批准 (L2)"],
  resubmit: ["Submit Ulang", "Resubmit", "重新提交"],
  archive: ["Arsipkan", "Archive", "归档"],
  reopen: ["Buka Revisi", "Reopen for Revision", "重新打开修改"],
  statusUpdated: ["Status diperbarui", "Status updated", "状态已更新"],
  revisionSent: ["Permintaan revisi dikirim", "Revision request sent", "修改请求已发送"],
  commentAdded: ["Komentar ditambahkan", "Comment added", "评论已添加"],
  uploaded: ["Lampiran diupload", "Attachment uploaded", "附件已上传"],
  downloadFail: ["Gagal mengunduh", "Download failed", "下载失败"],
  confirmDelete: ["Hapus transaksi ini?", "Delete this transaction?", "删除此交易？"],
  deleted: ["Transaksi dihapus", "Transaction deleted", "交易已删除"],
  detail: ["Detail Transaksi", "Transaction Detail", "交易详情"],
  txn: ["Transaksi", "Transaction", "交易"],
  fromInvoice: ["Dari pembayaran Invoice", "From invoice payment", "来自发票收款"],
  vendor: ["Vendor", "Vendor", "供应商"],
  bank: ["Akun Bank", "Bank Account", "银行账户"],
  rate: ["Kurs", "Rate", "汇率"],
  transferTo: ["Transfer Ke", "Transfer To", "转入"],
  received: ["Diterima / Selisih Kurs", "Received / FX Difference", "收到 / 汇兑差额"],
  gain: ["Laba", "Gain", "收益"],
  loss: ["Rugi", "Loss", "损失"],
  project: ["Project", "Project", "项目"],
  tax: ["Pajak", "Tax", "税"],
  createdBy: ["Dibuat oleh", "Created by", "创建人"],
  desc: ["Deskripsi", "Description", "描述"],
  statusNote: ["Catatan (opsional untuk approval/revisi)", "Note (optional, for approval / revision)", "备注（审批 / 修改用，可选）"],
  attachments: ["Lampiran", "Attachments", "附件"],
  discussion: ["Diskusi", "Discussion", "讨论"],
  history: ["Histori", "History", "历史"],
  uploadAtt: ["Upload Lampiran", "Upload Attachment", "上传附件"],
  noAtt: ["Belum ada lampiran", "No attachments yet", "暂无附件"],
  noDisc: ["Belum ada diskusi", "No discussion yet", "暂无讨论"],
  revision: ["Revisi", "Revision", "修改"],
  writeComment: ["Tulis komentar...", "Write a comment...", "写评论..."],
  sendComment: ["Kirim Komentar", "Send Comment", "发送评论"],
  by: ["oleh", "by", "由"],
  edit: ["Edit", "Edit", "编辑"],
  view: ["Lihat", "View", "查看"],
  download: ["Unduh", "Download", "下载"],
  allStatus: ["Semua Status", "All Statuses", "全部状态"],
  allProject: ["Semua Project", "All Projects", "全部项目"],
  year: ["Tahun", "Year", "年份"],
  all: ["Semua", "All", "全部"],
  allCoa: ["Semua COA", "All COA", "全部科目"],
  dateFrom: ["Dari tanggal", "From date", "开始日期"],
  dateTo: ["Sampai tanggal", "To date", "结束日期"],
  oldest: ["Terlama", "Oldest", "最早"],
  newest: ["Terbaru", "Newest", "最新"],
  date: ["Tanggal", "Date", "日期"],
  invoice: ["Invoice", "Invoice", "发票"],
  amount: ["Nominal", "Amount", "金额"],
  status: ["Status", "Status", "状态"],
  rows: ["baris", "rows", "行"],
  oldAttach: ["Untuk transaksi lama, tambah lampiran dari panel detail.", "For existing transactions, add attachments from the detail panel.", "已有交易请在详情面板添加附件。"],
  exportOk: ["Export berhasil", "Export complete", "导出成功"],
  exportBtn: ["Ekspor", "Export", "导出"],
  exportSel: ["Ekspor terpilih", "Export selected", "导出所选"],
  exported: ["transaksi diekspor", "transactions exported", "笔交易已导出"],
  reset: ["Reset", "Reset", "重置"],
  incl: ["termasuk", "incl.", "含"],
  autoJ: ["jurnal otomatis", "automatic journals", "笔自动分录"],
  total: ["Total", "Total", "合计"],
  totalTax: ["Total (DPP+PPN−PPh)", "Total (Base+VAT−WHT)", "合计（税基+增值税−预扣税）"],
  auto: ["Otomatis", "Automatic", "自动"],
  inTo: ["Masuk ke", "Into", "转入"],
  outFrom: ["Keluar dari", "Out of", "转出自"],
  gotAmt: ["Jumlah diterima", "Amount received", "收到金额"],
  kmkRate: ["Kurs KMK", "KMK rate", "KMK汇率"],
  notYet: ["belum tersedia", "not available yet", "暂不可用"],
  loading: ["memuat…", "loading…", "加载中…"],
  sentKmk: ["Nilai dikirim (KMK)", "Amount sent (KMK)", "转出金额（KMK）"],
  gotKmk: ["Nilai diterima (KMK)", "Amount received (KMK)", "收到金额（KMK）"],
  effRate: ["Kurs efektif", "Effective rate", "实际汇率"],
  fxGain: ["Laba selisih kurs", "FX gain", "汇兑收益"],
  fxLoss: ["Rugi selisih kurs", "FX loss", "汇兑损失"],
  fxNote: ["Otomatis dijurnal ke akun Laba/Rugi Selisih Kurs bila kurs berbeda dengan KMK.", "Automatically posted to the FX Gain/Loss account when the rate differs from KMK.", "汇率与KMK不同时，自动记入汇兑损益科目。"],
};
const IDX = { id: 0, en: 1, zh: 2 };
export const tx = (k, lang) => (D[k] ? D[k][IDX[lang] ?? 0] : k);

const ST = {
  draft: ["Draft", "Draft", "草稿"], review: ["Review", "Review", "待审核"], checked: ["Diperiksa", "Checked", "已审核"],
  revisi: ["Revisi", "Revision", "需修改"], approved: ["Approved", "Approved", "已批准"], archived: ["Archived", "Archived", "已归档"],
};
export const stLabel = (s, lang) => (ST[s] ? ST[s][IDX[lang] ?? 0] : s);

const ACT = {
  create: ["Dibuat", "Created", "已创建"], update: ["Diubah", "Updated", "已修改"], delete: ["Dihapus", "Deleted", "已删除"],
  bulk_update: ["Diubah massal", "Bulk updated", "批量修改"], recalc_fx_kmk: ["Kurs KMK dihitung ulang", "KMK rate recalculated", "KMK汇率已重算"],
};
// History action code ("create", "status:review->checked") -> readable text.
export const actLabel = (a, lang) => {
  const m = /^status:(\w+)->(\w+)$/.exec(a || "");
  if (m) return `${tx("status", lang)}: ${stLabel(m[1], lang)} → ${stLabel(m[2], lang)}`;
  return ACT[a] ? ACT[a][IDX[lang] ?? 0] : a;
};

const SRC = {
  invoice: ["Invoice", "Invoice", "发票"], fixed_asset: ["Aset Tetap", "Fixed Asset", "固定资产"], production: ["Produksi", "Production", "生产"],
  payroll: ["Payroll", "Payroll", "工资"], fx_reval: ["Selisih Kurs", "FX Revaluation", "汇兑重估"],
};
export const srcLabel = (s, fallback, lang) => (SRC[s] ? SRC[s][IDX[lang] ?? 0] : fallback || s);
export const dateLocale = (lang) => ({ en: "en-US", zh: "zh-CN" }[lang] || "id-ID");
